$(function () {
	var parentID = 1;
	var lastItem = {};

	$('.list-group').disableSelection();
	$('body').on('click', '.list-group .list-group-item', function (event) {
		//$(this).toggleClass('active');

		var $this = $(this);
		if($this.hasClass('disabled')) return;

		var $parent = $this.closest('ul');
		var id;
		if( $parent.length ) id = $parent.attr('id') || $parent.attr('id','ul-'+(parentID++)).attr('id');

		if(event.ctrlKey) {
			$this.toggleClass('active');
		} else {
			$this.closest('.list-group').find('.list-group-item').removeClass('active');
			$this.addClass('active');
		}

		if($this.hasClass('active')) {

			var $prev = $(lastItem[id]);
			if(typeof(lastItem[id])==='undefined' || $prev.css('display')==='none' || !event.shiftKey || $(lastItem[id]).closest('ul').attr('id') != $parent.attr('id')) {
				lastItem[id] = $this;
			} else {
				if($prev.length) {
					var select = false;
					$parent.children('li').each(function(index,element) {
						var $element = $(element);
						if(element===$prev[0] || element===$this[0]) {
							if(select) selectItem($element);
							select = !select;
						}
						if(select) selectItem($element);
					});
				}
			}
		} else {
			delete lastItem[id];
		}

	});

	function selectItem(item) {
		var $item = $(item);
		if($item.css('display')!=='none' && !$item.hasClass('disabled') ) $item.addClass('active');
	}

	$('.list-arrows button').live('click',function (event) {
		event.preventDefault();
		var $button = $(this), actives = '', id = $(this).attr("data"), selected = [];
		if ($button.hasClass('move-left')) {
			actives = $('#group'+id+' .list-right ul li.active');
			actives.removeClass("leftmargin");
			actives.clone().appendTo('#group'+id+' .list-left ul').removeClass('active').css('display','');
			actives.remove();
		} else if ($button.hasClass('move-right')) {
			actives = $('#group'+id+' .list-left ul li.active');
			actives.clone().appendTo('#group'+id+' .list-right ul').removeClass('active').css('display','');
			actives.remove();
		}
		$('#ulselected'+id+' li').each(function(index, element) {
			if($(this).hasClass("leftmargin")){
				selected.push("submenu###"+$(this).attr("data"));
			} else {
				selected.push($(this).attr("data"));
			}
        });
		$('#selected'+id).val(selected.join()).change();
		
		if ($(this).data('callback')) {
			var fname = $(this).data('callback');
			eval(fname + "()");
		}
		
	});
	$('.dual-list .selector').live('click',function () {
		var $checkBox = $(this);
		if (!$checkBox.hasClass('selected')) {
			$checkBox.addClass('selected').closest('.well').find('ul li').not('.active,:hidden,.disabled').addClass('active');
			$checkBox.children('i').removeClass('glyphicon-unchecked').addClass('glyphicon-check');
		} else {
			$checkBox.removeClass('selected').closest('.well').find('ul li.active').not(':hidden').removeClass('active');
			$checkBox.children('i').removeClass('glyphicon-check').addClass('glyphicon-unchecked');
		}
	});
	$('[name="SearchDualList"]').live('keyup',function (e) {
		var code = e.keyCode || e.which;
		if (code == '9') return;
		if (code == '27') $(this).val(null);
		var $rows = $(this).closest('.dual-list').find('.list-group li');
		var val = $.trim($(this).val()).replace(/ +/g, ' ').toLowerCase();
		$rows.show().filter(function () {
			var text = $(this).text().replace(/\s+/g, ' ').toLowerCase();
			return !~text.indexOf(val);
		}).hide();
	});
	$(".sortableduallist").sortable({
		axis:'y',
		update: function( event, ui ) {
			selected = [];
			var id = $(this).attr("id").replace("ulselected","");
			$("#ulselected"+id+" li").each(function(index, element) {
				if($(this).hasClass("leftmargin")){
					selected.push("submenu###"+$(this).attr("data"));
				} else {
					selected.push($(this).attr("data"));
				}
			});
			$("#selected"+id).val(selected.join());
		}
    }).disableSelection();

});